import { useState } from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

const LINES = [
  { drop: "pup", name: "Project PUPS", color: "#5eead4" },
  { drop: "exclusive", name: "Exclusive", color: "#facc15" },
  { drop: "wolfpack", name: "Wolfpack (777)", color: "#cbd5e1" },
  { drop: "rare", name: "1 of 1 Rare PUPS", color: "#f472b6" },
];

export default function AdminSalesChart({ daily }) {
  const [metric, setMetric] = useState("revenue");
  const money = metric === "revenue";
  return (
    <div className="glass rounded-2xl p-6" data-testid="admin-sales-chart">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="text-sm text-amber-300 font-semibold">Daily drop sales · all time</p>
        <div className="flex rounded-full border border-slate-700 p-0.5 text-xs">
          {[["revenue", "Revenue ($)"], ["sold", "NFTs sold"]].map(([k, l]) => (
            <button key={k} data-testid={`admin-sales-chart-${k}-btn`} onClick={() => setMetric(k)}
              className={`px-3 py-1 rounded-full transition-colors ${metric === k ? "bg-amber-400 text-black" : "text-slate-300 hover:text-white"}`}>{l}</button>
          ))}
        </div>
      </div>
      {!daily.length ? <p className="text-sm text-slate-500 py-10 text-center" data-testid="admin-sales-chart-empty">No paid drop sales yet. The chart fills in from the first sale.</p> : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={daily} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
              <CartesianGrid stroke="#1e293b" strokeDasharray="3 3" />
              <XAxis dataKey="date" stroke="#64748b" fontSize={11} tickFormatter={(d) => d.slice(5)} />
              <YAxis stroke="#64748b" fontSize={11} allowDecimals={money} tickFormatter={(v) => (money ? `$${v}` : v)} />
              <Tooltip contentStyle={{ background: "#061016", border: "1px solid #334155", borderRadius: 12 }} formatter={(v) => (money ? `$${Number(v).toFixed(2)}` : v)} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {LINES.map((l) => <Line key={l.drop} type="monotone" dataKey={`${l.drop}_${metric}`} name={l.name} stroke={l.color} strokeWidth={2} dot={{ r: 3 }} />)}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
